import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import ActionButton from '../ActionButton'

export const Inner = styled.section`
  padding-top: 3.5rem;
  & > *:not(:first-child) {
    margin-top: 3rem;
    @media print {
      margin-top: 1rem;
    }
  }
  @media ${mq(sizes.desktop)} {
    padding-top: 5rem;
    & > *:not(:first-child) {
      margin-top: 3rem;
    }
  }

  @media print {
    padding-top: 0;
  }
`

export const SectionTitle = styled.h2`
  ${({ theme }) => theme.textStyles.titleH2_23}
  padding: 0;
  margin: 0;
  text-align: center;
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.titleH2_30}
  }
`

export const ControlNumber = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  & > *:not(:first-child) {
    margin-left: 3rem;
  }
  & > span {
    ${({ theme }) => theme.textStyles.text_bold_14}
  }
  @media ${mq(sizes.desktop)} {
    & > span {
      ${({ theme }) => theme.textStyles.text_bold_22}
    }
  }
  @media print {
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
    & > span {
      margin-left: 0 !important;
    }
  }
`

export const ControlNumberButton = styled(ActionButton)`
  ${({ theme }) => theme.textStyles.text_14}
  @media print {
    display: none;
  }
`

export const Warning = styled.p`
  ${({ theme }) => theme.textStyles.text_16}
  text-align: center;
  color: ${({ theme }) => theme.colors.error};
  ${Inner} > &:not(:first-child) {
    margin-top: 1rem;
  }
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_18}
    ${Inner} > &:not(:first-child) {
      margin-top: 2rem;
    }
  }
`

export const List = styled.dl<{ $numberOfElements: number }>`
  @media print, ${mq(sizes.desktop)} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: min-content;
    grid-auto-flow: column;
    break-inside: avoid;
    ${({ $numberOfElements }) => {
      const firstColumnElements = Math.ceil($numberOfElements / 2)
      return `
        & > * {
          grid-column-start: 1;
        }
        & > *:nth-child(${firstColumnElements}) ~ * {
          grid-column-start: 2;
        }
        & > *:nth-child(${firstColumnElements}), & > *:nth-child(${
        firstColumnElements + firstColumnElements
      }) {
          border-bottom: 0;
        }
      `
    }}
  }

  @media print {
    column-gap: 1.5rem;
  }
`

export const ListItem = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding-top: 1.4rem;
  padding-bottom: 1.4rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyDD};
  font-size: 1.6rem;
  & dt {
    ${({ theme }) => theme.fonts.HelveticaNeueBold}
  }
  & dd {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
    flex-shrink: 0;

    span:nth-child(2) {
      ${({ theme }) => theme.fonts.HelveticaNeueLt}
    }

    & > * {
      padding-left: 1.5rem;
      text-align: right;
    }
  }
  @media ${mq(sizes.desktop)} {
    flex: 0 0 calc(50% - 4rem);
    padding-top: 1.8rem;
    padding-bottom: 1.8rem;
    font-size: 1.8rem;
    margin-left: 2rem;
    margin-right: 2rem;
    border-bottom-width: 2px;
  }

  @media print {
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-size: 1.5rem;
    border-bottom-width: 2px;
  }
`

export const Notes = styled.p`
  ${({ theme }) => theme.textStyles.text_16}
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_14}
  }
`
